import { buildLinkResetHeader, buildSocialIconTd } from './shared';

export default (brand) => ({
  id: 1,
  name: 'Template #2',
  height: 140,
  params: ['name', 'title', 'office', 'mobile', 'email', 'website', 'facebook', 'instagram', 'linkedin', 'twitter'],
  source: `${buildLinkResetHeader({ text: brand.text })}

<table id="body" cellpadding="0" cellspacing="0" style="width: 500px;border-collapse: collapse;" width="500" border="0">
  <tr>
    <td valign="top" style="padding-bottom: 8px;">
      <table cellpadding="0" cellspacing="0" style="width: 500px;" width="500" border="0">
        <tr>
          <td valign="bottom" align="left" style="width: 388px;" width="388">
            <table cellpadding="0" cellspacing="0" style="width: 388px;" width="388" border="0">
              {% if name %}
                <tr>
                  <td style="color: ${brand.text}; font-size: 16px; font-family: Helvetica, Arial, sans-serif; line-height: 20px; mso-line-height-rule: exactly;">
                    <b>{{- name -}}</b>
                  </td>
                </tr>
              {% endif %}
              {% if title %}
                <tr>
                  <td style="color: ${brand.text}; font-size: 14px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; line-height: 20px; mso-line-height-rule: exactly;">
                    {{- title -}}
                  </td>
                </tr>
              {% endif %}
            </table>
          </td>
          <td valign="bottom" align="right" style="width: 112px;" width="112">
            <table border="0" cellpadding="0" cellspacing="0">
              <tr>
${buildSocialIconTd({ indent: 18, field: 'facebook', type: 'facebook', alt: 'facebook', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'instagram', type: 'instagram', alt: 'instagram', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'linkedin', type: 'linkedin', alt: 'linkedin', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'twitter', type: 'x', alt: 'twitter', background: 'none', color: brand.primaryNoHash, radius: 4 })}
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td valign="top" style="padding-top: 8px;border-top: 2px solid ${brand.text};">
      <table cellpadding="0" cellspacing="0" style="width: 500px;" width="500" border="0">
        <tr>
          <td valign="middle" align="left" style="width: 296px;" width="296">
            <table cellpadding="0" cellspacing="0" style="width: 296px;" width="296" border="0">
              {% if website %}
                <tr>
                  <td style="line-height: 16px; padding-bottom: 4px;">
                    <a
                      href="{{ website }}"
                      style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                    >
                      {{- website -}}
                    </a>
                  </td>
                </tr>
              {% endif %}
              {% if office %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=phone&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="phone"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="tel:{{office}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- office -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if mobile %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=mobile&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="mobile"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="tel:{{mobile}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- mobile -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if email %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=email&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="email"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="mailto:{{email}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- email -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
            </table>
          </td>
          <td valign="middle" align="right" style="width: 200px;padding-right: 4px;" width="200">
            <a href="{{ website }}" target="_blank" style="text-decoration: none;display: inline-block;">
              <img
                src="${brand.logoUrl}"
                alt="Company logo"
                style="width: 200px;height: auto;display: block;border: 0;outline: none;"
                width="200"
              >
            </a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`
});
